export default __webpack_public_path__ + "static/media/AI-logo.a0b7f892.svg";